
export default {
  data() {
    return {
      options: [
        {
          name: 'link',
          label: 'Poveznica',
          type: 'link',
        },
      ],
    }
  },
  methods: {
    scrollUnder() {
      const element = document.getElementById('boxHero')
      let y = element.scrollHeight
      document.body.scrollTop = y
      document.documentElement.scrollTop = y
    },
  },
}
